var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _polygon, _polygon2, _path30, _path31, _path32, _polygon3, _path33, _path34, _path35, _path36, _path37, _path38, _polygon4, _polygon5, _polygon6, _path39, _g, _path40, _path41, _g2, _g3, _path42, _path43, _path44, _path45, _rect2, _g4, _path46, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLomasetapa5Vertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.9,
    cy: 62.7,
    r: 0.3,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 53,
    width: 38.8,
    height: 5.8,
    fill: "#93b63a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2,9.9c0,5.4-4.3,9.7-9.7,9.7s-9.7-4.3-9.7-9.7S21.1.2,26.5.2c5.4,0,9.7,4.3,9.7,9.7",
    fill: "#e4ca3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9,13.3h4.9s1.7,1.6,1.7,5-1.3,6.8.3,9.8c-1.2,1.6-3.8,2.6-3.8,2.6l-3.9-1s-1.4-1.1,0-5.8c1.3-4.7,2.2-7.6.9-10.7",
    fill: "#93b63a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7,21.1h1c0-.1,0-.3.1-.5h-1c0,.2,0,.4,0,.5",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9,20.1h1c0-.2,0-.3,0-.5h-1.1c0,.2,0,.4,0,.5",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18.5c0,.2,0,.3,0,.5h1c0-.2,0-.3,0-.5h-1Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18h1.1c0-.2,0-.4,0-.5h-1c0,.2,0,.3,0,.5",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9,16.9h1.1c0-.2,0-.3,0-.5h-1c0,.2,0,.3,0,.5",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8,15.9c0-.2-.1-.4-.2-.5h-1c0,.1,0,.3.1.5h1Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,12h4.9s1.7,1.6,1.7,5-1.3,6.8.3,9.8c-1.2,1.6-3.8,2.6-3.8,2.6l-3.9-.9s-1.4-1.1,0-5.8c1.3-4.7,2.2-7.6.9-10.7",
    fill: "#529047"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9,10.4h5.2s1.9,2,1.9,5.4-1.4,7.8.2,10.8c-1.2,1.6-4,1.2-4,1.2h-3.5c0,0-2.2-1.9-.8-6.6,1.4-4.7,2.3-7.8.9-10.8",
    fill: "#3e6b3b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6,18.5h1.2c0-.2.1-.4.2-.7h-1.1c0,.3-.2.5-.2.7",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9,17.4h1.1c0-.2.1-.4.2-.7h-1.1c0,.2-.1.5-.2.7",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,16.4h1.1c0-.2,0-.5.1-.7h-1.1c0,.2,0,.4-.1.7",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3,15.2s0,.1,0,.2h1.1c0-.2,0-.3,0-.4s0-.2,0-.3h-1.1c0,.2,0,.3,0,.5",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4,14.3h1c0-.2,0-.4,0-.7h-1c0,.2,0,.4,0,.7",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4,13.3c0-.2,0-.4,0-.7h-1c0,.2,0,.4.1.7h1Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3,13.8c-.2,0-.4-.2-.7,0-.2.2,0,.6-.2.6-.2,0-.2-.2-.6,0-.5.3,0,.5,0,.6-.1.1-.8.1-1,.6-.2.5.3.5.2.7,0,.2-.4,0-.6.2-.2.3.1.4,0,.5,0,0-.2,0-.2.5,0,.4-.4-.4-.6.6,0,.3.4.5.4.7,0,.2-.7.2-.5.6.2.5.4,0,.5.2,0,.2-.4.5,0,.8.4.3.4,0,.5.2.1.2,0,.5.6.7.6.1,1.4,0,1.8.2.5.2.5.2.8,0,.3-.1.4-.6.8-.5.5.1.8,0,1.1-.2.3-.2.3-.2.7-.1.4,0,.5,0,.6-.4,0-.3-.2-.7-.1-.9.1-.2.6,0,.6-.4,0-.5-.7-.9-.7-1.2,0-.2.4.2.4-.3,0,0-.1,0-.3-.2-.1-.2-.2-.5-.4-.5-.2,0-.3-.1-.1-.2.2,0,.3-.3.2-.4-.2,0-.4,0-.4-.2,0-.2.3-.1.2-.4-.1-.3-.7-.4-.7-.5,0-.2.4-.3.2-.5-.2-.2-.6-.2-.9-.2-.2,0,0-.2-.3-.4-.3-.2-.4,0-.5,0-.1,0,0-.5-.5-.6-.4,0-.5.2-.5.2",
    fill: "#529047"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2,21.5c0,.3.1.6-.2.9-.3.3.3.3,1.1.3.8,0,0-.2.1-.7,0-.4,0-1.2,0-1.2l-1.1.6",
    fill: "#44743e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3,21.1c-.2,0-.4.1-.4.1-.2.2-.3.4,0,.5.2.1.2.2.1.4,0,.1-.1.2,0,.3,0,0,.2.1.3.2.7,0,0-.2,0-.7,0-.3,0-.7,0-.9",
    fill: "#3e6b3b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8,14.2c0,.2,0,.4,0,.6-.2.3-.5.5-.3.7.3.2,1.2.6,1.1,1,0,.5-.9.6-1,.9,0,.4,1,.4.9.9-.2.9-2.1.4-2.2,1.1,0,.4,1.2.2.4,1-.7.7-2,.9-2.7,1,0,0,0,0,.1,0,.6.1,1.4,0,1.8.2.5.2.5.2.8,0,.3-.1.4-.6.8-.5.5.1.8,0,1.1-.2.3-.2.3-.2.7-.1.4,0,.5,0,.6-.4,0-.3-.2-.7-.1-.9.1-.2.6,0,.6-.4,0-.5-.7-.9-.7-1.2,0-.2.4.2.4-.3,0,0-.1,0-.3-.2-.1-.2-.2-.5-.4-.5-.2,0-.3-.1-.1-.2.2,0,.3-.3.2-.4-.2,0-.4,0-.4-.2,0-.2.3-.1.2-.4-.1-.3-.7-.4-.7-.5,0-.2.4-.3.2-.5-.2-.2-.6-.2-.9-.2-.2,0,0-.2-.3-.3",
    fill: "#3e6b3b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6,22.4c0,.1,0,.3,0,.4-.1.1-.3.3-.4.4,0,0,.7-.1.8-.2.1,0,.1-.2.1-.4,0-.2,0-.4,0-.5,0-.1-.6.2-.6.2",
    fill: "#44743e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2,22.6c0,0,0-.2,0-.3,0,0-.2,0-.2.1-.2.1,0,0,0,.3,0,.2,0,.1.2,0,0,0,0-.1,0-.2",
    fill: "#3e6b3b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2,22.3s.3,0,.5,0c.2,0,.3-.2.5-.2.2,0,.5,0,.5-.2,0-.2-.1-.3,0-.4,0,0,.3,0,.3-.3s-.2-.3-.2-.6c0-.3.1,0,0-.3-.1-.3-.3-.1-.3-.3,0-.2.2,0,.1-.2,0,0-.2,0-.2-.2,0-.1.2-.2,0-.3-.1-.2-.3,0-.3-.2,0-.1.2-.1,0-.3-.2-.1-.3,0-.4,0,0,0,0-.2,0-.3-.1,0-.2.1-.3,0,0,0-.2-.4-.4-.2,0,0-.3,0-.4.1-.1.2,0,.2-.2.3-.1,0-.3-.1-.4.1,0,.2.2.2,0,.3-.2,0-.4,0-.5.3,0,.3.2.2.1.4,0,.1-.3,0-.3.2,0,.2,0,.2,0,.3-.1,0,0,0-.1.2-.1.1-.3.3-.2.5,0,.2.1.2.1.3s-.2,0-.2.2c0,.2.1,0,.2.2,0,.2-.2.2,0,.4.1.2.3,0,.4.1,0,.1,0,.3.3.4.2,0,.7,0,.9,0,.2,0,.3.1.5.1.2,0,.3-.2.5-.2",
    fill: "#529047"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,21.1c0-.2-.2-.3-.2-.6,0-.3.1,0,0-.3-.1-.3-.3-.1-.3-.3,0-.2.2,0,.1-.2,0,0-.2,0-.2-.2,0-.1.2-.2,0-.3-.1-.2-.3,0-.3-.2,0-.1.2-.1,0-.3-.2-.1-.3,0-.4,0,0,0,0-.2,0-.3,0,0,0,0,0,0,0,0,0,.2,0,.3-.2.2-.3.3,0,.5.2.2.6.3.6.6,0,.2-.5.3-.5.5s.5.3.4.5c0,.3-1.2.2-1.2.6,0,.3.7,0,.3.5-.3.4-1.1.5-1.6.6,0,0,0,0,0,0,.2,0,.7,0,.9,0,.2,0,.3.1.5.1.2,0,.3-.2.5-.2,0,0,.3,0,.5,0,.2,0,.3-.2.5-.2.2,0,.5,0,.5-.2,0-.2-.1-.3,0-.4,0,0,.3,0,.3-.3",
    fill: "#3e6b3b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7,25.6s3,1.8,7.3,1.8,11.4-5.1,19.7-5.1,11.6,4.2,11.6,4.2v3.7s-5.8-3.5-9.8-3.5c-8.9,0-12.8,5-20,5s-8.8-2.3-8.8-2.3v-3.7Z",
    fill: "#bcc933"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4,26.5c4.1,0,9.8,3.5,9.8,3.5v-.5c-1.9-1.4-6.9-4.8-12.3-4.8s-13.3,5.2-19.5,5.2-5.5-.9-6.8-1.5v.8s3.3,2.3,8.8,2.3,11.1-5,20-5",
    fill: "#529047"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4,26.5c4.1,0,9.8,3.5,9.8,3.5v-.2c-5.8-4-10.1-4.6-14.5-3.9-4.5.7-9.7,4.8-17.7,4.9-2.5,0-5.6-1.4-6.4-1.8v.3s3.3,2.3,8.8,2.3,11.1-5,20-5",
    fill: "#3e6b3b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,37.9c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5,1.4,0,2.5,1.1,2.5,2.5",
    fill: "#1a1918"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11,37.9c0,1.1-.8,1.9-1.9,1.9s-1.9-.9-1.9-1.9.9-1.9,1.9-1.9,1.9.9,1.9,1.9",
    fill: "#e4ca3b"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5.5 34.2 5.5 41.5 7.3 41.5 7.3 42.4 4.5 42.4 4.5 34.2 5.5 34.2",
    fill: "#1a1918"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "16 39.3 18.2 34 20.1 42.4 19.1 42.4 17.9 37 16 41.8 13.9 37.1 12.9 42.4 11.9 42.4 13.6 34 16 39.3",
    fill: "#1a1918"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2,42.4h-1l-.9-2.7h-1.8l-.9,2.7h-1l2.8-8.4,2.8,8.4ZM23.4,36.7l-.6,2.1h1.2l-.6-2.1Z",
    fill: "#1a1918"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2,35.2c-.4-.2-.6-.2-.9-.2-.5,0-.9.3-.9.8s.1.5.4.6c.2,0,.3.1.8.3.7.2,1.1.4,1.5.7.6.5,1,1.4,1,2.2,0,1.6-1.3,3-3,3s-1.1-.1-1.9-.7v-1.5c.2.4.4.5.6.7.4.3.9.5,1.4.5,1.1,0,2-.9,2-2s-.4-1.4-1-1.8c-.2-.1-.4-.2-1.1-.4-.7-.2-.9-.3-1.2-.6-.3-.3-.4-.7-.4-1.1,0-1,.8-1.7,1.9-1.7.3,0,.5,0,.9.2v1Z",
    fill: "#1a1918"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,33.9c1.1,0,1.9.3,2.7.9,1.1.8,1.7,2.1,1.7,3.4s-.8,3.1-2.2,3.8c-.7.4-1.3.6-2.2.6v-8.7ZM36.5,41.4c1.4-.4,2.4-1.7,2.4-3.2s-1-2.8-2.4-3.2v6.4Z",
    fill: "#1a1918"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "43.4 34 43.4 35 41.6 35 41.6 37 42.9 37 42.9 38 41.6 38 41.6 41.5 43.4 41.5 43.4 42.4 40.6 42.4 40.6 34 43.4 34",
    fill: "#1a1918"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,51.1c-1.8,0-3.3-1.5-3.3-3.3s1.4-3.2,3.2-3.3v.7c-.4,0-.7,0-1.1.3-.9.5-1.5,1.3-1.5,2.3s.5,1.8,1.5,2.3c.4.2.6.3,1.1.3v.7Z",
    fill: "#1a1918"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,51h-.8l-.7-2.1h-1.4l-.7,2.1h-.8l2.1-6.4,2.2,6.4ZM9.9,46.6l-.4,1.6h.9l-.5-1.6Z",
    fill: "#1a1918"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7,44.7c.8,0,1.1,0,1.5.4.6.4.9,1,.9,1.7s-.3,1.3-.9,1.7l1.4,2.6h-.9l-1.6-2.9c.7-.2,1.1-.7,1.1-1.3,0-.7-.5-1.3-1.2-1.3v5.5h-.7v-6.3h.3Z",
    fill: "#1a1918"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6,51h-.8l-.7-2.1h-1.4l-.7,2.1h-.8l2.1-6.4,2.1,6.4ZM17.5,46.6l-.4,1.6h.9l-.5-1.6Z",
    fill: "#1a1918"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,44.7c.6,0,.9,0,1.3.3.4.3.6.7.6,1.2,0,.4-.1.7-.4.9.8.3,1.3,1,1.3,1.9,0,.7-.4,1.4-1.1,1.8-.4.2-.6.2-1.3.2h-.7v-6.3h.4ZM20.6,47c.4,0,.7-.4.7-.8s-.3-.7-.7-.8v1.6ZM20.9,50.3c.8,0,1.4-.5,1.4-1.3s-.6-1.3-1.4-1.3h-.1v2.6s.2,0,.2,0Z",
    fill: "#1a1918"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2,51h-.8l-.7-2.1h-1.4l-.7,2.1h-.8l2.1-6.4,2.1,6.4ZM25,46.6l-.4,1.6h.9l-.5-1.6Z",
    fill: "#1a1918"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "31.6 44.7 29.6 47.2 29.6 51 28.9 51 28.9 47.2 26.8 44.7 27.8 44.7 29.2 46.5 30.7 44.7 31.6 44.7",
    fill: "#1a1918"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "32.6 44.7 32.6 50.3 33.9 50.3 33.9 51 31.9 51 31.9 44.7 32.6 44.7",
    fill: "#1a1918"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.2 44.7 35.2 50.3 36.6 50.3 36.6 51 34.5 51 34.5 44.7 35.2 44.7",
    fill: "#1a1918"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,47.8c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3,1.5-3.3,3.3-3.3,3.2,1.5,3.2,3.3M37.5,47.8c0,1.4,1.1,2.5,2.5,2.5,1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.6-2.5c-1.4,0-2.5,1.1-2.5,2.5",
    fill: "#1a1918"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.3,57.7c-.1,0-.2-.2-.3-.3,0-.1,0-.2,0-.4v-2.6s0,0,0,0h.4s0,0,0,0v2.6c0,0,0,.1,0,.2,0,0,0,0,.1,0h1.3c0,0,.1,0,.1,0,0,0,0,0,0-.2v-2.6s0,0,0,0h.4s0,0,0,0v2.6c0,.1,0,.3,0,.4,0,.1-.1.2-.3.3-.1,0-.2,0-.3,0h-1.3c-.1,0-.2,0-.3,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,54.5h.3s0,0,0,0l1.7,2.2s.1,0,.1,0v-2.1s0,0,0,0h.4s0,0,0,0v3.3s0,0,0,0h-.3s0,0,0,0l-1.7-2.2s-.1,0-.1,0v2.2s0,0,0,0h-.4s0,0,0,0v-3.3s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,54.5h.4s0,0,0,0v3.3s0,0,0,0h-.4s0,0,0,0v-3.3s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,54.5l.9,2.7c0,0,0,0,.1,0l.9-2.7s0,0,0,0h.4s0,0,0,0l-1.1,3.3s0,0,0,0h-.6s0,0,0,0l-1.1-3.3s0,0,0,0h.4s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6,54.5h2.4s0,0,0,0v.4s0,0,0,0h-1.9s0,0,0,0v.8s0,0,0,0h1.8s0,0,0,0v.4s0,0,0,0h-1.8s0,0,0,0v.8s0,0,0,0h1.9s0,0,0,0v.4s0,0,0,0h-2.4s0,0,0,0v-3.3s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,56.7h-.9s0,0,0,0v1s0,0,0,0h-.4s0,0,0,0v-3.3s0,0,0,0h1.9c.1,0,.2,0,.3,0,.1,0,.2.1.2.3,0,.1,0,.2,0,.4v.8c0,.2,0,.4-.2.5,0,.1-.2.2-.4.2s0,0,0,0l.6,1s0,0,0,0h-.4s0,0,0,0l-.7-1.1s0,0,0,0ZM22.4,56.2c0,0,.1,0,.1,0,0,0,0,0,0-.2v-.8c0,0,0-.1,0-.1s0,0-.1,0h-1.4s0,0,0,0v1.1s0,0,0,0h1.4Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1,57.8c-.2,0-.4-.2-.5-.4s0-.2,0-.4v-.2s0,0,0,0h.4s0,0,0,0v.2c0,0,0,.1,0,.1,0,0,0,0,.1,0h1.3c0,0,.1,0,.1,0,0,0,0,0,0-.1v-.4c0,0,0-.1,0-.2s-.1,0-.2,0h-1.2c-.1,0-.3,0-.4,0-.1,0-.2-.2-.3-.3,0-.1,0-.2,0-.4v-.5c0-.1,0-.2,0-.4,0-.1.1-.2.2-.3.1,0,.2,0,.3,0h1.4s0,0,0,0c.2,0,.4.2.5.4,0,.1,0,.2,0,.4v.3h-.5v-.3c0,0,0-.1,0-.1,0,0,0,0-.1,0h-1.3c0,0-.1,0-.1,0,0,0,0,0,0,.1v.4c0,0,0,.1,0,.2,0,0,.1,0,.2,0h1.1c.1,0,.3,0,.4,0,.1,0,.2.2.3.3,0,.1,0,.2,0,.4v.5c0,.1,0,.3,0,.4,0,.1-.1.2-.2.2-.1,0-.2,0-.3,0h-1.4s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7,54.5h.4s0,0,0,0v3.3s0,0,0,0h-.4s0,0,0,0v-3.3s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6,55h-1s0,0,0,0v-.4s0,0,0,0h2.6s0,0,0,0v.4s0,0,0,0h-1s0,0,0,0v2.7s0,0,0,0h-.4s0,0,0,0v-2.7s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2,54.5h.6s0,0,0,0l1.3,3.3s0,0,0,0h-.4s0,0,0,0l-.3-.8s0,0,0,0h-1.5s0,0,0,0l-.3.8s0,0,0,0h-.4s0,0,0,0l1.3-3.3s0,0,0,0ZM32.1,56.4l-.5-1.3s0,0-.1,0l-.5,1.3s0,0,0,0h1s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,56.7h-.9s0,0,0,0v1s0,0,0,0h-.4s0,0,0,0v-3.3s0,0,0,0h1.9c.1,0,.2,0,.3,0,.1,0,.2.1.2.3,0,.1,0,.2,0,.4v.8c0,.2,0,.4-.2.5,0,.1-.2.2-.4.2s0,0,0,0l.6,1s0,0,0,0h-.4s0,0,0,0l-.7-1.1s0,0,0,0ZM35.5,56.2c0,0,.1,0,.1,0,0,0,0,0,0-.2v-.8c0,0,0-.1,0-.1s0,0-.1,0h-1.4s0,0,0,0v1.1s0,0,0,0h1.4Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,54.5h.4s0,0,0,0v3.3s0,0,0,0h-.4s0,0,0,0v-3.3s0,0,0,0Z",
    fill: "#1a1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,54.5h.6s0,0,0,0l1.3,3.3s0,0,0,0h-.4s0,0,0,0l-.3-.8s0,0,0,0h-1.5s0,0,0,0l-.3.8s0,0,0,0h-.4s0,0,0,0l1.3-3.3s0,0,0,0ZM39.7,56.4l-.5-1.3s0,0-.1,0l-.5,1.3s0,0,0,0h1s0,0,0,0Z",
    fill: "#1a1918"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1,73.2c1.9-1.3,4.3-1.2,6,.4.4.4.8.8,1.2,1.1.8.7,1.9,1.3,2.9.9.5-.2.9-.7,1.1-1.1,0,0,0,0,0,0,0,0,0,0,0,0-.4.7-1.1,1.4-2,1.3-1.4,0-2.4-1.3-3.4-2.2-1.7-1.6-4.1-1.8-6-.4h0Z",
    fill: "#2294c6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9,61.9H5.9c-.8,0-1.4.6-1.4,1.3v8.7c0,.7.6,1.3,1.4,1.3h36c.8,0,1.4-.6,1.4-1.3v-8.7c0-.7-.6-1.3-1.4-1.3ZM23.9,63.1c-.2,0-.3-.1-.3-.3s.1-.3.3-.3.3.1.3.3-.1.3-.3.3Z",
    fill: "#dd4f13"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.7,70.3h-3.9v-5h3.9v1.1h-2.7v.9h2.4v1h-2.4v.9h2.7v1.1Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,66.4v3.9h-1.2v-3.9h-1.6v-1.1h4.5v1.1h-1.6Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,70.3l-.4-.9h-2.1l-.4.9h-1.3l2.1-5h1.3l2.1,5h-1.3ZM21.1,66.7l-.6,1.6h1.3l-.6-1.6Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7,65.3c1.1,0,1.8.7,1.8,1.7s-.7,1.8-1.9,1.8h-1.2v1.5h-1.2v-5h2.5ZM26.6,67.8c.5,0,.8-.3.8-.7s-.3-.7-.8-.7h-1.1v1.4h1.1Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3,70.3l-.4-.9h-2.1l-.4.9h-1.3l2.1-5h1.3l2.1,5h-1.3ZM30.9,66.7l-.6,1.6h1.3l-.6-1.6Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6,67.1c1.1,0,1.8.6,1.8,1.6s-.7,1.8-1.9,1.8-1.9-.6-1.9-1.7l1.2-.2c0,.7.4.9.8.9s.7-.3.7-.7-.3-.6-.7-.6h-1.7v-2.8h3.4v1.1h-2.2v.7s.7,0,.7,0Z",
    fill: "#fdfdfd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "31.8 71.5 32.3 72.4 32.7 73.2 31.3 74.7 30.5 72.8 31.2 72.1 31.8 71.5 31.8 71.5",
    fill: "#63c3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9,71.6c0,.9-.2,2-.5,3.1h0s0,0,0,0h0c.3-1.1.6-2.2.5-3.1h0s0,0,0,0h0Z",
    fill: "#44d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,72.8c.1,0,.7,0,1.3,0,.3,0,.5.2.8.3,0,0,.1,0,.2,0h0s0,0,0,0c0,0-.1,0-.2,0-.2,0-.5-.2-.7-.2-.6-.1-1.2,0-1.3,0h0s0,0,0,0h0Z",
    fill: "#44d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4,73.1s0,0,0,0c0,0,0,0,0,0,0,0,0,0,.1,0,0,0,0,0-.2,0,0,0,0,0,0,0-.2,0-.5,0-.8,0,0-.1,0-.2,0-.3.2,0,.4.1.6.2h0s0,0,0,0h0Z",
    fill: "#44b7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7,72.9c0,.1,0,.2,0,.3-.6-.1-.6-.1-1.2-.4,0,0,.2,0,.4,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.3,0,.5,0h0Z",
    fill: "#44b7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7,73.2h0s0,0,0,0c0-.1,0-.2,0-.3,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.3h0Z",
    fill: "#2cf",
    fillRule: "evenodd"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,62.9c-.2,0-.3,0-.5,0h0s0,0,0,0c.3-.7,1-1.2,1.7-1.2.3,0,.5,0,.6.2.1.2,0,.4,0,.6-.1.2-.3.3-.5.3-.4.1-.8.2-1.2.2ZM24,62.7c.5,0,1,0,1.5-.2.1,0,.3-.1.4-.3,0-.1.1-.3,0-.4,0-.1-.3-.1-.5-.1-.6,0-1.2.4-1.5,1Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23,63c-.3,0-.7,0-1-.1,0,0-.2,0-.2-.1,0,0-.1-.2-.1-.3,0-.2.1-.3.4-.3.7-.2,1.5,0,2,.6h0s0,.1,0,.1c-.3.1-.7.2-1,.2ZM22.5,62.2c-.2,0-.3,0-.5,0,0,0-.2,0-.2.2,0,0,0,0,0,.1,0,0,.1,0,.2,0,.5.2,1.1.2,1.7,0-.3-.3-.8-.5-1.2-.5Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9,64.3s0,0,0,0c0,0,0-.1,0-.1.6-.2.9-.8.9-1.4,0,0,0,0,0,0,0,0,0,0,0,0,0,.7-.4,1.3-1,1.6,0,0,0,0,0,0Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7,63.6s0,0,0,0c-.4-.1-.7-.5-.8-.9,0,0,0-.1,0-.1,0,0,.1,0,.1,0,0,.4.3.7.7.8,0,0,0,0,0,.1,0,0,0,0,0,0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: 58.8,
    width: 0.2,
    height: 3.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: 59.3,
    width: 0.2,
    height: 3.6
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1,61.7c.8-.8,1.9-1.3,3-1.3.6,0,1.1.1,1.6.3.5.2,1,.5,1.4.9,1.7,1.9,2.4,4.4,4.8,1.3,0,0,0,0,0,0,0,0,0,0,0,0-.3.4-.7.9-1.2,1.2-.9.6-1.6.2-2.2-.6-.5-.6-1-1.4-1.5-2-.4-.4-.8-.8-1.3-.9-.5-.2-1.1-.3-1.6-.3-1.1,0-2.2.4-3,1.2h0Z",
    fill: "#e58b0a"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "47.7 59.7 47.8 60.9 48 62 45.8 63.1 45.6 60.7 46.7 60.2 47.7 59.7 47.7 59.7",
    fill: "#fc0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7,59.8c-.3,1.1-1,2.1-1.8,3.2h0s0,0,0,0h0c.8-1.1,1.6-2.2,1.8-3.3h0s0,0,0,0h0Z",
    fill: "#fea000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7,60.6c.2,0,.8.2,1.4.6.3.2.5.4.7.6,0,0,.1.1.2.1h0s0,0,0,0c0,0-.1,0-.2-.2-.2-.2-.4-.4-.7-.6-.6-.3-1.3-.5-1.4-.6h0s0,0,0,0h0Z",
    fill: "#fea000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7,61.7s0,0,0,0c0,0,0,0,0,0,0,0,0,0,.1.1,0,0,0,0-.2,0,0,0,0,0,0,0-.3,0-.6-.2-.8-.3,0-.2.1-.2.2-.4.2.1.4.3.6.4h0s0,0,0,0h0Z",
    fill: "#dcb000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,61.2c0,.2-.1.2-.2.4-.6-.4-.7-.4-1.1-.9,0,0,.2,0,.4.1,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.4.2.5.3h0Z",
    fill: "#dcb000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9,61.6h0s0,0,0,0c0-.2.1-.2.2-.4,0,0,0,0,0,0,0,0,0,0,0,0,0,.2-.1.2-.2.4h0Z",
    fill: "#dc8700",
    fillRule: "evenodd"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,74.2c-.3-1.1-1-2-1.9-2.6-.5-.3-1-.4-1.6-.6-.5,0-1.1,0-1.6.1-.5.2-1,.4-1.5.6-.7.3-1.6.8-2.4.4-.7-.5-.8-1.5-1-2.3,0,0,0,0,0,0,0,0,0,0,0,0,.5,3.9,2.3,2,4.8,1.3.5-.2,1.1-.2,1.6-.1.5.1,1.1.3,1.6.6,1,.6,1.7,1.5,1.9,2.6h0Z",
    fill: "#2b660c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1.3 66.4 .6 67.4 0 68.2 1.4 70.2 2.7 68.2 2 67.2 1.3 66.4 1.3 66.4",
    fill: "#b2d72d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3,66.5c-.3,1.1,0,2.3.1,3.7h0c0,0,0,0,0,0h0c-.2-1.4-.4-2.7,0-3.7h0s0,0,0,0h0Z",
    fill: "#289119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7,68.1c-.2,0-.8-.2-1.5-.2-.3,0-.7,0-.9.2,0,0-.1,0-.2,0h0s0,0,0,0c0,0,.1,0,.2,0,.2,0,.6-.2.9-.2.7,0,1.4.1,1.5.2h0s0,0,0,0h0Z",
    fill: "#289119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.4,68.2s0,0-.1,0c0,0,0,0,0,0,0,0-.1,0-.1,0,0,0,0,0,.2,0,0,0,0,0,0,0,.2,0,.6,0,.9,0,0-.2,0-.2,0-.4-.2,0-.5,0-.7.1h0s0,0,0,0h0Z",
    fill: "#99b92a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2,68c0,.2,0,.2,0,.4.7,0,.8,0,1.4-.3,0,0-.2,0-.4,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.1,0-.2,0-.2,0-.4,0-.6,0h0Z",
    fill: "#99b92a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2,68.4h0s0,0,0,0c0-.2,0-.2,0-.4,0,0,0,0,0,0,0,0,0,0,0,0,0,.2,0,.2,0,.4h0Z",
    fill: "#207915",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLomasetapa5Vertical);
export default __webpack_public_path__ + "static/media/Lomas etapa 5 Vertical.a3a66940bdcfec52b2e3d53eafaee438.svg";
export { ForwardRef as ReactComponent };